// 项目设置模块
export default {
    SetUp: {
        AnswerSet: 'Answer Set',
        QualitySettings: 'Quality settings',
        PublicSettings: 'Public settings',
        OtherSettings: 'Other settings',
        CanOnly: 'Can only',
        EveryHour: 'Every hour',
        EveryDay: 'Every day',
        Weekly: 'Weekly',
        Monthly: 'Monthly',
        Thanking: 'Your answer sheet has been submitted. Thank you for participating!',
        OnlyWeChatAnswerQuestions: 'Only allow WeChat to answer questions',
        WeChatRestrictions: 'Limit on the number of times each WeChat question can be answered',
        PleaseSelect: 'Please select',
        Answer: 'Answer',
        PleaseEnterContent: 'Please enter content',
        Times: 'Times',
        ComputerOrPhoneRestrictions: 'Limit the number of times each computer or phone can answer questions',
        IPRestrictions: 'Limit on the number of times each IP can answer questions',
        ActivateAccessPassword: 'Activate access password',
        EnterTheAccessPassword: 'Please enter the access password',
        MailOnly: 'Only respondents invited by email can answer',
        SetTime: 'Set start/end time',
        SetStartTime: 'Set Start Time',
        NoRestrictions: 'No restrictions',
        SetEndTime: 'Set End Time',
        EndTimeGreaterThanStartTime: 'The end time needs to be later than the start time',
        SetDataUpperLimit: 'Set the upper limit of data',
        Collect: 'Collect',
        EndOfData: 'End when copying data',
        ControlPageFillingTime: 'Control page filling time',
        Limitation: 'limitation',
        TimedOutAutomaticSubmission: 'complete the questionnaire within minutes, and automatically submit all content if it expires',
        SetQuotas: 'Set quotas',
        PublicSettings: 'Public settings',
        ShareButton: "Display the 'Share' button to share links to more social media sites (computer answer pages only)",
        AnswerSquare: 'Whether to publish to the Respondent Square',
        OtherSettings: 'Other settings',
        CustomJump: 'Customize the jump after completing the answer',
        SettableVariables: 'Variable can be set, for example',
        QuestionnaireIdentification: 'Questionnaire identification',
        UserId: 'User ID, valid only for login questions',
        ThirdParty: 'Third party docking system ID, only valid for docking questions',
        UniqueId: 'Unique ID for each respondent"',
        Staging: 'Enable temporary storage for answer sheet',
        ThirdPartyTitle: 'Third party interface docking settings',
        SatisfactionScore: 'Enable satisfaction score summary',
        TotalScoreFormula: 'Total score formula',
        RandomSettings: 'Random settings',
        DockingSettings: 'Docking Settings',
        IsTheQuestionnaireValid: 'Is the questionnaire valid',
        SetEffectiveTime: 'Set effective time (days)',
        SynchronizeSamples: 'Synchronize sample parameter settings',
        RuleSettings: 'Questionnaire Rule Settings',
        SampleParameters: 'Sample parameter settings',
        Add: 'Add',
        FieldName: 'Field name',
        EnglishName: 'Field Name in English',
        Close: 'Close',
        PleaseEnterAFieldName: 'Please enter a field name',
        PleaseEnterAnEnglishName: 'Please enter the English name of the field',
        ReturnVisitChannels: 'Return visit channels',
        FollowUpType: 'Types of follow-up visits',
        ValidOrNot: 'Valid or not',
        DeleteIt: 'Are you sure to delete it?',
        AddRuleSettings: 'Add questionnaire rule settings',
        RuleType: 'Rule Type',
        SelectARuleType: 'Please select a rule type',
        RuleChannel: 'Rule Channel',
        SelectARuleChannel: 'Please select a rule channel',
        EditQuestionnaireRuleSettings: 'Edit questionnaire rule settings',
        NameOfFollowUpVisit: 'Name of follow-up visit',
        RuleName: 'Rule Name',
        ModifyQuestionnaireRules: 'Modify questionnaire rule settings',
        WeChatSettings: 'WeChat settings',
        QuerySettings: 'Query Settings',
        SampleSettings: 'Sample Settings',
        PrizesAndRedEnvelopes: 'Prizes and red envelopes',
        JumpToTheSpecifiedPage: 'Jump to the specified page (example https://www.surveytree.org）',
        PleaseEnterTheAddress: 'Please enter the address',
        PleaseSelectWhetherItIsValid: 'Please select whether it is valid',
        DoNotSet: 'Do not set',
        RandomizeByQuestion: 'Randomize by question',
        RandomByPage: 'Random by page',
        PiecewiseRandom: 'Piecewise random',
        NewlyAdded: 'Newly added',
        StartingQuestion: 'Starting Question',
        StartNum: 'The question number must not be less than 1 and greater than the total number of questions',
        ToTheEndQuestion: 'To the end question',
        EndNum: 'The question number must not be less than 1 and greater than the total number of questions',
        Randomizing: 'Randomizing',
        TheCurrentRangeOnlyHas:'The current range only has',
        Questions: 'Questions',
        Question: 'Question',
        FromStartPage: 'From Start Page',
        pageStartNum: 'Page number should not be less than 1 and greater than the total number of pages',
        ToEndPage: 'To End Page',
        PageEndNum: 'Page number should not be less than 1 and greater than the total number of pages',
        Page: 'Page',
        Pages: 'Pages',
        NumberOfQuestions: 'Number of questions',
        ShowOnlySomeTitlesOnThisPage: 'Show only some titles on this page',
        RandomFunction: 'Random function',
        RemoveObstaclesFrom: 'Remove obstacles from',
        TheCurrentPageHas: 'The current page has',
        Tip: 'Tip',
        CheckOn: 'If the questionnaire contains "logical settings," "association logic," and "citation logic," setting random questions may cause these logic to become invalid. Please check!',
        MoreThanTwoQuestions: 'Only when there are more than two questionnaire questions can this option be selected',
        GotIt: 'Got it',
        OverTwoPages: 'This option can only be selected if the number of questionnaire pages exceeds two or more',
        Yes: 'Yes',
        No: 'No',
    },
  };